module.exports = {
    THEME: '#d82238',
    SECONDARY: '#971726',
    RED: {
        DARKEST: '#660000',
        DARK: '#9f0006',
        MEDIUM: '#d7142c',
        LIGHT: '#fa5255',
        LIGHTEST: '#ff938a'
    },
    BLUE: {
        DARKEST: '#002058',
        DARK: '#0d4b8b',
        MEDIUM: '#4f76bb',
        LIGHT: '#81a4ed',
        LIGHTEST: '#b8d8ff'
    },
    GREEN: {
        DARKEST: '#062900',
        DARK: '#2f5526',
        MEDIUM: '#5d8351',
        LIGHT: '#8db580',
        LIGHTEST: '#c0e9b2'
    },
    VIOLET: {
        DARKEST: '#0b1235',
        DARK: '#383961',
        MEDIUM: '#666591',
        LIGHT: '#9694c3',
        LIGHTEST: '#cac7f8'
    },
    TEAL: {
        DARKEST: '#00201c',
        DARK: '#034c47',
        MEDIUM: '#397973',
        LIGHT: '#69a9a2',
        LIGHTEST: '#9bdcd5'
    },
    SKYBLUE: {
        DARKEST: '#002749',
        DARK: '#005278',
        MEDIUM: '#0082a9',
        LIGHT: '#08b4dd',
        LIGHTEST: '#66e6ff'
    },
    EMERALDGREEN: {
        DARKEST: '#002400',
        DARK: '#004e2d',
        MEDIUM: '#007d57',
        LIGHT: '#04ae84',
        LIGHTEST: '#4ce0b3'
    },
}